import { Box, Grid } from "@mui/material"
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs"
import DrawerHeader from "components/DrawerHeader"
import { CommonTexts } from "locale/es"
import DisplayPatients from "./DisplayPatients"
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const PatientsManagement = () =>
  <Box component="main" sx={{ flex: 1, p: 3, mb: 20 }}>
    <DrawerHeader />
    <BreadCrumbs name={CommonTexts.PATIENTS} icon={<PersonAddIcon sx={{ mr: 0.5 }} fontSize="inherit" />} />
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <DisplayPatients />
    </Grid>
  </Box>

export default PatientsManagement